"use client";
import { MaterialSymbol } from "material-symbols";
import { useState } from "react";
import { CtaQueryResult } from "../../../sanity/queries";
import { splitOptionalStegaLabel } from "../../../sanity/stega";
import LinkSolstice from "../../shared/LinkSolstice/LinkSolstice";
import { MaterialIcon } from "../../shared/MaterialIcon/MaterialIcon";
import styles from "./EmergencyBanner.module.scss";

interface EmergencyBannerProps {
	bannerId?: string | null;
	cta?: CtaQueryResult | null;
	icon?: string | null;
	message?: string | null;
}

export const EmergencyBanner = ({ cta, icon, message }: EmergencyBannerProps) => {
	const [isDismissed, setIsDismissed] = useState(false);
	const ctaLabel = splitOptionalStegaLabel(cta?.label);

	return (
		!isDismissed && (
			<div className={styles["emergency"]}>
				<div className={styles["emergency__inner"]}>
					<div className={styles["emergency__content-wrapper"]}>
						<div className={styles["emergency__content"]}>
							{icon && <MaterialIcon name={icon as MaterialSymbol} />}

							{message && <span className={styles["emergency__message"]}>{message}</span>}
						</div>
						{cta && cta.link && (
							<LinkSolstice
								className={styles["emergency__link"]}
								href={cta.link}
							>
								<span
									className={styles["emergency__link-text"]}
									data-sanity={ctaLabel.dataSanity}
								>
									{ctaLabel.text}
								</span>

								<MaterialIcon
									className={styles["emergency__link-arrow"]}
									name="arrow_right_alt"
								/>
							</LinkSolstice>
						)}
					</div>

					<button
						className={styles["emergency__dismiss"]}
						aria-label={`Dismiss message: ${message}`}
						onClick={() => setIsDismissed(true)}
					>
						<MaterialIcon name="close" />
					</button>
				</div>
			</div>
		)
	);
};
